export default __webpack_public_path__ + "3149a5c9dfd9c8d7a2fbc1b09fbcd9b8.svg";